<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_103_24)">
<path d="M63.4636 25.1881H69.2529V13.8962C69.2529 13.8962 64.0013 13 58.9826 13C48.4973 13 41.6504 19.354 41.6504 30.852V40.961H30V54.2245H41.6504V86.29H55.9894V54.2245H66.6809L68.7152 40.961H55.9894V32.3576C55.9894 28.728 57.7638 25.1881 63.4636 25.1881Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_103_24">
<rect width="39.2529" height="73.29" fill="white" transform="translate(30 13)"/>
</clipPath>
</defs>
</svg>

</template>
